import { render, staticRenderFns } from "./T1ATabsContent.vue?vue&type=template&id=6bde82e4&scoped=true&"
import script from "./T1ATabsContent.vue?vue&type=script&lang=js&"
export * from "./T1ATabsContent.vue?vue&type=script&lang=js&"
import style0 from "./T1ATabsContent.vue?vue&type=style&index=0&id=6bde82e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde82e4",
  null
  
)

export default component.exports